/**
 * FE-C2g batch-8: Auth shell — login, session, health, CSRF contract paths.
 */

import { buildContractPath } from "./api/contract-client.js";

export const AUTH_LOGOUT_TIMEOUT_MS = 8000;
export const AUTH_ME_TIMEOUT_MS = 12000;
export const AUTH_LOGIN_TIMEOUT_MS = 15000;
export const AUTH_HEALTH_TIMEOUT_MS = 12000;
export const AUTH_CSRF_TIMEOUT_MS = 12000;

export function buildPostAuthLogoutPath() {
  return buildContractPath("post__auth_logout");
}

export function buildGetAuthMePath() {
  return buildContractPath("get__auth_me");
}

export function buildGetHealthPath() {
  return buildContractPath("get__health");
}

export function buildPostAuthLoginPath() {
  return buildContractPath("post__auth_login");
}

export function buildPostAuthLoginEmailSecondPath() {
  return buildContractPath("post__auth_login_email-second");
}

export function buildPostAuthCodeResendPath() {
  return buildContractPath("post__auth_code_resend");
}

export function buildGetAuthCsrfPath() {
  return buildContractPath("get__auth_csrf");
}

/** @param {number} [rev] — avatar revision for cache bust */
export function buildGetAuthMeAvatarPath(rev) {
  const r = Number(rev) >>> 0;
  return buildContractPath("get__auth_me_avatar", r ? { query: { v: String(r) } } : undefined);
}

/** Public signup / activate / recovery (no session cookie). */
export function buildPostAuthSignupStartPath() {
  return buildContractPath("post__auth_signup_start");
}

export function buildPostAuthSignupVerifyPath() {
  return buildContractPath("post__auth_signup_verify");
}

export function buildPostAuthActivatePath() {
  return buildContractPath("post__auth_activate");
}

export function buildGetAuthForgotEmailEnabledPath() {
  return buildContractPath("get__auth_forgot_email_enabled");
}

export function buildPostAuthForgotEmailCheckPath() {
  return buildContractPath("post__auth_forgot_email_check");
}

export function buildPostAuthForgotEmailStartPath() {
  return buildContractPath("post__auth_forgot_email_start");
}

export function buildPostAuthForgotEmailCompletePath() {
  return buildContractPath("post__auth_forgot_email_complete");
}
